
const CircularTip = () => {
};

export default CircularTip;